module.exports = {"542526100":"改则镇","542526200":"物玛乡","542526201":"先遣乡","542526202":"麻米乡","542526203":"洞措乡","542526204":"古姆乡","542526205":"察布乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/542526.json
// module id = 2774
// module chunks = 0